import React from 'react';
import {
    IconHeart,
    IconCheckbox,
    IconUsers,
    IconFolder,
    IconBell
} from '@tabler/icons-react';
import Button from '../../../../../components/ui/Button';

export const NotificationFilter = ({ currentFilter, handleFilterChange, unreadCount }) => {
    const filterOptions = [
        { key: 'all', label: 'All', icon: IconBell },
        { key: 'unread', label: 'Unread', icon: IconCheckbox },
        { key: 'social', label: 'Social', icon: IconHeart },
        { key: 'projects', label: 'Projects', icon: IconUsers },
        { key: 'solutions', label: 'Solutions', icon: IconFolder }
    ];

    return (
        <div className="notification-filters">
            {filterOptions.map(({ key, label, icon: Icon }) => (
                <Button
                    key={key}
                    variant={currentFilter === key ? "primary" : "ghost"}
                    size="sm"
                    onClick={() => handleFilterChange(key)}
                    className={`rounded-full gap-2 min-w-[100px] ${currentFilter === key ? '' : 'text-gray-500'}`}
                >
                    <Icon size={16} />
                    {label}
                    {key === 'unread' && unreadCount > 0 && (
                        <span className="ml-1 bg-white text-primary-600 px-1.5 py-0.5 rounded-full text-[10px] font-bold shadow-sm">
                            {unreadCount}
                        </span>
                    )}
                </Button>
            ))}
        </div>
    );
};
